enum EnumUserPaymentsType {
	ClearJunction = 0,
	Offline = 1,
	ClearJunctionIban = 3,
	Payneteasy = 4
}
export default EnumUserPaymentsType
